import { useRouter } from 'vue-router'
import { useUserStore } from '@/store/modules/user'
import { ONBOARDING_STEPS } from '@/apps/traforama/constants'
import { ElMessage } from 'element-plus'

export function useOnboardingRedirect() {
  const userStore = useUserStore()
  const router = useRouter()

  const processOnboarding = async (withRedirect: boolean = true) => {
    if (!userStore.isProcessingOnboarding) return false

    await userStore.GetUserInfo(false)

    const nextExpectedPath = ONBOARDING_STEPS[userStore.onboardingStep].href
    const message =
      ONBOARDING_STEPS[userStore.onboardingStep - 1].success_message

    if (nextExpectedPath) {
      if (withRedirect) router.push(nextExpectedPath)

      ElMessage.success({
        message,
        type: 'success',
        duration: 5000
      })
      return true
    }

    return false
  }

  return { processOnboarding }
}
